import axios from 'axios'
import { API_ROOT } from '../constants'
import { TIMEZONE } from '../constants/currency'

export const getOAuthUrl = (provider, modal = false) =>
  `${API_ROOT}/v3/oauth/${provider}?timeZone=${encodeURIComponent(TIMEZONE)}${modal ? '&behavior=modal' : ''}`

export const loginWithEmail = async (data, headers = {}) => {
  return axios.post(
    `${API_ROOT}/v3/login`,
    { ...data, timeZone: TIMEZONE },
    {
      headers: {
        'Content-Type': 'application/json',
        ...headers
      }
    }
  )
}

export const loginWithPassword = async (data) => {
  return axios.post(
    `${API_ROOT}/v3/auth/password`,
    { ...data, timeZone: TIMEZONE },
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  )
}

export const verifyOTPCode = async (email, code) => {
  return axios.get(`${API_ROOT}/v3/auth`, {
    params: { email: email.toLowerCase().trim(), code, timeZone: TIMEZONE }
  })
}

export const discoverSsoLogin = async (email) => {
  return axios.post(
    `${API_ROOT}/v3/sso/login/discover`,
    { email: email.toLowerCase().trim() },
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  )
}

export const getSsoLoginStartUrl = (email) =>
  `${API_ROOT}/v3/sso/login/start?email=${encodeURIComponent(email.toLowerCase().trim())}`
